import { requestGetForm, requestPost } from "@/config/http-json";

const assistant = {
  async records(data) {
    return await requestGetForm("/omni/assistant/selectAssistantRecord", data, { showLoading: false });
  },
  async sendMessage(data) {
    const resp = await requestPost("/omni/assistant/sendMessage", { ...data, showLoading: false });
    return resp.data;
  }
};

export default assistant;